import React from 'react';
import {useSelector} from "react-redux";
import '../index.css'
import Typewriter from '../../../../comm/textShow'


const DictionaryAnswer = (props) =>  {

    const {answer} = props
    const {size} = useSelector(state => state.fontSizeChange)
    const answerThree = {
        fontSize: size === '小' ? '14px' : (size === '中' ? '16px' : '18px'),
        paddingTop:'5px',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    }
    return (
        <div>
                {
                    answer&&answer.length>0?
                    answer.map((res,i)=>{
                        return (
                            <div style={answerThree} key={'tran-an'+i}>
                                {
                                    answer?.textShow?<Typewriter text={res.text}/>:<span>{res.text}</span>
                                }
                            </div>
                        )
                    }):''
                }
        </div>
    );
}


export default DictionaryAnswer
